import { useEffect, useState } from 'react';
import { api, fmt, fmtDate, getUser } from '../api';
import { useToast, Loading, ErrorBox } from '../ui';

export default function Shortages() {
  const [list, setList] = useState<any[] | null>(null);
  const [err, setErr] = useState('');
  const toast = useToast();
  const user = getUser();
  const canEdit = ['admin', 'zakaz_operator'].includes(user?.role);

  const load = () => { setErr(''); api.get('/shortages?status=open').then(setList).catch((e) => { setErr(e.message); setList([]); }); };
  useEffect(() => { load(); }, []);

  const writeOff = async (id: number) => {
    const reason = prompt('Hisobdan chiqarish sababi (zavod yubormadi / yo\'qoldi / rad qilindi):');
    if (!reason) return;
    try { await api.patch(`/shortages/${id}/write-off`, { reason }); toast('Hisobdan chiqarildi'); load(); }
    catch (e: any) { toast(e.message, true); }
  };

  const days = (d: string) => Math.floor((Date.now() - new Date(d).getTime()) / 86400000);

  return (
    <div>
      <div className="page-head">
        <div><h1 className="page-title">Yetmovchiliklar reyestri</h1><p className="page-sub">{list ? list.length : '—'} ta ochiq yetmovchilik</p></div>
      </div>
      {err ? <ErrorBox text={err} onRetry={load} /> : !list ? <Loading /> : list.length === 0 ? <div className="card"><p className="muted">Ochiq yetmovchilik yo'q ✅</p></div> : (
        <div className="table-wrap">
          <table>
            <thead><tr><th>Artikul</th><th>Nomi</th><th>Zakaz</th><th>Zavod</th><th>Zakaz sanasi</th><th className="num">Yetmayapti</th><th className="num">Kutish (kun)</th><th></th></tr></thead>
            <tbody>
              {list.map((s) => {
                const d = days(s.orderItem.order.orderDate);
                return (
                  <tr key={s.id}>
                    <td>{s.orderItem.product.article}</td><td>{s.orderItem.product.name}</td>
                    <td>{s.orderItem.order.number}</td><td>{s.orderItem.order.supplier?.name || '—'}</td>
                    <td>{fmtDate(s.orderItem.order.orderDate)}</td>
                    <td className="num">{fmt(s.qtyMissing)}</td>
                    <td className="num" style={{ color: d > 30 ? 'var(--danger)' : undefined }}>{d}</td>
                    <td>{canEdit && <button className="btn btn-sm" onClick={() => writeOff(s.id)}>Hisobdan chiqarish</button>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
